module.exports = __webpack_public_path__ + "img/airplane.b305c446.gif";